<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col md="12">
          <v-card flat class="text-right v-card-bg-none">
            <v-card-actions>
              <v-btn color="primary" outlined class="mr-1" to="/admin/courses">
                <v-icon class="mr-1" small>fa-chevron-left</v-icon>Back to
                Course List
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            class="search-box"
            placeholder="Search Users By Name Or Email"
            prepend-icon="fa-search"
            v-model="search"
            type="text"
            clearable
            clear-icon="fa-times"
            @click:clear="resetSearch"
            @change="applySearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="email-button-wrapper" v-if="serverItemsLength > 0">
          <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="showCompletedUserPanel()"
            outlined
          >
          Archive Course Data for User(s)
          </v-btn>
          <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="exportCsv('excel')"
            outlined
          >
          Email link to download Excel report
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': ''}"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}"></v-skeleton-loader>                    
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 25, 50, 75, 100, -1],
              }"
            >
              <template
                v-slot:item.usercourses.last_completed_event_date="{ item }"
              >
                {{ item.usercourses.last_completed_event_date }}
              </template>
              <template v-slot:item.usercourses.progress="{ item }">
                {{ item.usercourses.progress }}%
                <!--<v-progress-linear
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 2"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 5"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="item.usercourses.state == 3"
                  :value="item.usercourses.progress"
                  color="primary"
                  height="20"
                ></v-progress-linear>-->
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip left v-if=" item.usercourses.history_exists">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click.prevent="
                        showUserCourseHistoryPanel(item.usercourses.id)
                      "
                    >
                      <v-icon small>fas fa-history</v-icon>
                    </v-btn>
                  </template>
                  <span>View Completed Course History</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import courseAPI from '@/api/course.js';
import LayoutBasic from '@/layouts/Dashboard';
import ShowUserCourseHistory from '@/components/admin/course/ShowUserCourseHistory';
import CompletedUserPanel from '@/components/admin/course/CompletedUsers';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'CourseDetailsReport',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Enrolled Date', value: 'usercourses.enrolled_date_formatted' },
        { text: 'Deadline', value: 'usercourses.deadline_formatted' },
        { text: 'Started Date', value: 'usercourses.start_date_formatted' },
        {
          text: 'Date Completed',
          value: 'usercourses.complete_date_formatted',
        },
        { text: 'Last Accessed', value: 'usercourses.last_accessed_date' },

        { text: 'Progress', value: 'usercourses.progress' },
        { text: 'Test Score', value: 'usercourses.test_score' },
        { text: 'Attempts', value: 'usercourses.attempts' },
        { text: '', value: 'id', align: 'end' },
      ],
      id: this.$route.params.id,
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return (
        this.$gf.getQueryString(this.options, this.serverItemsLength) +
        this.searchParams +
        '&include='
      );
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getEnrolledUsers() {
      this.loading = true;
      courseAPI
        .getCourseEnrolledUsers(this.id, this.params + 'usercourses')
        .then((resp) => {
          this.users = [];
          resp.data.data.forEach((item) => {
            item.usercourses = item.usercourses.data.filter((userCourse) => {
              return userCourse.course_id == this.id;
            });
            item.usercourses = item.usercourses[0];
            this.users.push(item);
          });
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getEnrolledUsers();
    },
    applySearch() {
      if(this.search === null){
        this.searchParams = '';
      }else {
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' + 
        this.search + ';email:' + this.search;
      }
      this.getEnrolledUsers();
    },
    exportCsv(type) {
      this.loading = true;
      let searchVar = '';
      if (this.search) {
        searchVar =
          '&search=first_name:' + this.search + ';last_name:' + this.search;
      }

      courseAPI
        .exportEnrolledUsers(
          this.id,
          '?page=1&orderBy=&sortedBy=asc&limit=' +
            this.pagination.total +
            '&include=' +
            'usercourses' +
            '&type=' +
            type +
            searchVar
        )
        .then((resp) => {
          this.$snotify.success(this.successMessage);
          // window.open(resp.data);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    showUserCourseHistoryPanel(id) {
      this.$showPanel({
        component: ShowUserCourseHistory,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCompletedUserPanel(){
      this.$showPanel({
        component: CompletedUserPanel,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('COURSE_USERS_ARCHIVED', () => {
        this.getEnrolledUsers();
      });
    },
  },
};
</script>

<style scoped>
.email-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

@media (max-width: 960px) {
  .email-button-wrapper {
    justify-content: start;
  }
}
</style>
